module.exports = __webpack_public_path__ + "img/TriangleShark-Mouth-Closed.413a2b5c.png";